var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1T(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 24,
    viewBox: "0 0 107 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8149_121521)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1513 5.68304L23.7033 8.68324C23.5887 8.76062 23.5199 8.88989 23.5199 9.02816V14.476C23.5199 14.7056 23.7062 14.892 23.9359 14.892C24.0188 14.892 24.0998 14.8672 24.1686 14.8208L28.6166 11.8206C28.7312 11.7432 28.8 11.614 28.8 11.4757V6.02797C28.8 5.79815 28.6137 5.61197 28.384 5.61197C28.3011 5.61197 28.22 5.63671 28.1513 5.68304ZM15.1999 4.38749V23.584C15.1999 23.8138 15.3861 24 15.6159 24C15.6988 24 15.7798 23.9753 15.8485 23.9289L21.7365 19.9574C21.8512 19.8801 21.9199 19.7509 21.9199 19.6125V0.416005C21.9199 0.18624 21.7337 0 21.5039 0C21.421 0 21.34 0.0247655 21.2713 0.071171L15.3833 4.04263C15.2687 4.11998 15.1999 4.24918 15.1999 4.38749ZM6.87989 4.38749V23.584C6.87989 23.8138 7.06613 24 7.29589 24C7.3788 24 7.45979 23.9753 7.52853 23.9289L13.4165 19.9574C13.5312 19.8801 13.5999 19.7509 13.5999 19.6125V0.416005C13.5999 0.18624 13.4137 0 13.1839 0C13.101 0 13.0199 0.0247655 12.9513 0.071171L7.06328 4.04263C6.94865 4.11998 6.87989 4.24918 6.87989 4.38749ZM4.63127 5.68304L0.183237 8.68324C0.068644 8.76062 -0.00012207 8.88989 -0.00012207 9.02816V14.476C-0.00012207 14.7056 0.186119 14.892 0.415883 14.892C0.498792 14.892 0.579784 14.8672 0.64852 14.8208L5.09652 11.8206C5.21115 11.7432 5.27988 11.614 5.27988 11.4757V6.02797C5.27988 5.79815 5.09364 5.61197 4.86388 5.61197C4.781 5.61197 4.70001 5.63671 4.63127 5.68304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.988 17.2638H98.8037L97.792 16.2521V14.1993H99.8448V15.2111H104.962V13.173H101.883V11.1202H104.962V9.05277H99.8448V10.0791H97.792V8.04105L98.8037 7H105.988L107 8.04105V11.1202L105.988 12.1466L107 13.173V16.2521L105.988 17.2638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4683 15.2111H94.5739V9.05277H90.4683V15.2111ZM86.3775 17.2638H84.3247V7H86.3775V11.1202H88.4156V8.04105L89.442 7H95.5856L96.612 8.04105V16.2521L95.5856 17.2638H89.442L88.4156 16.2521V13.173H86.3775V17.2638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7099 15.2111H80.8271V9.05277H75.7099V15.2111ZM81.8535 17.2638H74.6688L73.6571 16.2521V8.04105L74.6688 7H81.8535L82.8652 8.04105V16.2521L81.8535 17.2638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.329 17.2638H64.1443L63.1326 16.2521V8.04105L64.1443 7H71.329L72.3407 8.04105V10.0791H70.3026V9.05277H65.1853V15.2111H70.3026V14.1993H72.3407V16.2521L71.329 17.2638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6729 17.2638H50.6202V9.05277H47.0278V7H56.236V9.05277H52.6729V17.2638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8528 17.2638H36.8V7H38.8528V13.8328L43.9701 7H46.0082V17.2638H43.9701V10.4164L38.8528 17.2638Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8149_121521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1T);
export default __webpack_public_path__ + "static/media/logo-1T.d1e8238fa7d77ef397e5a10c337e53d8.svg";
export { ForwardRef as ReactComponent };